import { formatNa, formatMsisdn } from '@dch/common-utils';
import cloneDeep from 'lodash.clonedeep';
// Ref: This seems specific to mobile ui, as in web we need to style differently the inner content of the label.
// It might need to be extracted.
/**
 * @deprecated
 */
export function getAccountNumbersLabel(moreNumbersCount, mainAssociatedNumber, moreNumbersTranslation) {
    return {
        label: mainAssociatedNumber +
            (moreNumbersCount > 0 ? ` + ${moreNumbersCount} ${moreNumbersTranslation}` : ''),
        pressable: moreNumbersCount > 0,
    };
}
export function transformAssociatedNumbers(associatedNumbers, noFixedAndMsisdnTranslation, noProductLinkedTranslation) {
    var _a, _b, _c;
    const fixedNumbers = ((_a = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.fixed) !== null && _a !== void 0 ? _a : []).map(formatNa);
    const msisdnNumbers = ((_b = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.msisdn) !== null && _b !== void 0 ? _b : []).map((msisdn) => formatMsisdn(msisdn));
    const otherNumbers = (_c = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.other) !== null && _c !== void 0 ? _c : [];
    const moreAssociatedNumbers = [];
    let mainAssociatedNumber;
    if (fixedNumbers.length > 0) {
        mainAssociatedNumber = fixedNumbers[0];
        moreAssociatedNumbers.push(...fixedNumbers.slice(1), ...msisdnNumbers);
    }
    else if (msisdnNumbers.length > 0) {
        mainAssociatedNumber = msisdnNumbers[0];
        moreAssociatedNumbers.push(...msisdnNumbers.slice(1));
    }
    else if (otherNumbers.length > 0) {
        mainAssociatedNumber = noFixedAndMsisdnTranslation;
    }
    else {
        mainAssociatedNumber = noProductLinkedTranslation;
    }
    return { mainAssociatedNumber, moreAssociatedNumbers };
}
function isAccountActive(account) {
    var _a, _b, _c, _d;
    return (Number(account.balance) !== 0 ||
        ((_b = (_a = account.associatedNumbers) === null || _a === void 0 ? void 0 : _a.msisdn) !== null && _b !== void 0 ? _b : []).length > 0 ||
        ((_d = (_c = account.associatedNumbers) === null || _c === void 0 ? void 0 : _c.fixed) !== null && _d !== void 0 ? _d : []).length > 0);
}
function filtersOutLongFixedNumbers(billingAccount) {
    var _a, _b;
    if (((_a = billingAccount.associatedNumbers) === null || _a === void 0 ? void 0 : _a.fixed) !== undefined) {
        const accountWithFilteredFixedNumbers = cloneDeep(billingAccount);
        /* istanbul ignore else - cloneDeep does not take into account that "fixed" field will never be undefined due to first if */
        if (((_b = accountWithFilteredFixedNumbers.associatedNumbers) === null || _b === void 0 ? void 0 : _b.fixed) !== undefined) {
            accountWithFilteredFixedNumbers.associatedNumbers.fixed =
                billingAccount.associatedNumbers.fixed.filter((value) => value.length <= 10);
        }
        return accountWithFilteredFixedNumbers;
    }
    return billingAccount;
}
function filterActiveAccounts(billingAccounts) {
    return billingAccounts.filter(isAccountActive).map(filtersOutLongFixedNumbers);
}
function filterInactiveAccountsWithOtherAssociatedNumbers(billingAccounts) {
    return billingAccounts.filter((billingAccount) => { var _a, _b; return ((_b = (_a = billingAccount.associatedNumbers) === null || _a === void 0 ? void 0 : _a.other) !== null && _b !== void 0 ? _b : []).length > 0; });
}
/**
 * Returns active accounts (removes fixed numbers > 10 digits).
 * If none, fallbacks to inactive accounts with "other" associated numbers.
 */
export function filterViewableBillingAccounts(billingAccounts) {
    const activeAccounts = filterActiveAccounts(billingAccounts);
    return activeAccounts.length > 0
        ? activeAccounts
        : filterInactiveAccountsWithOtherAssociatedNumbers(billingAccounts);
}
export function getFormattedFixedAndMsisdnAssociatedNumbers(associatedNumbers) {
    var _a, _b;
    const fixed = (_a = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.fixed.map((fixedNumber) => formatNa(fixedNumber))) !== null && _a !== void 0 ? _a : [];
    const msisdn = (_b = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.msisdn.map((msisdnNumber) => formatMsisdn(msisdnNumber))) !== null && _b !== void 0 ? _b : [];
    return fixed.concat(msisdn);
}
export function isDirectDebitPaymentMethod(paymentMethod) {
    return paymentMethod === 'DD' || paymentMethod === 'CC';
}
export function isManualPaymentMethod(paymentMethod) {
    return paymentMethod === 'OK';
}
export function hasAnyNumber(associatedNumbers) {
    var _a, _b, _c, _d, _e, _f;
    const fixedLength = (_b = (_a = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.fixed) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    const msisdnLength = (_d = (_c = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.msisdn) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    const otherLength = (_f = (_e = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.other) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
    return fixedLength !== 0 || msisdnLength !== 0 || otherLength !== 0;
}
